import React from 'react';
import PropTypes from 'prop-types';

import Webhook from './SettingComponent/webhook';
import './MerchantDetails.scss';

const COMPONENT_MAP = {
  Webhook
};

function SettingTemplate({ type, data }) {
  const Component = COMPONENT_MAP[type];
  return (
    <div style={{ margin: '16px' }} className="setting-template">
      {Component ? <Component data={data} /> : <div>🚧 Coming soon...</div>}
    </div>
  );
}

SettingTemplate.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      url: PropTypes.string
    })
  )
};

SettingTemplate.defaultProps = {
  data: []
};

export default SettingTemplate;
